export default __webpack_public_path__ + "static/media/icon_warning.1b3578e0.svg";